import { createFileRoute, redirect } from '@tanstack/react-router';
import { MainApplicationDashboard } from '../components/layout/MainApplicationDashboard';
import { Layout } from '../components/layout/Layout';

const DashboardPage = () => (
  <Layout>
    <MainApplicationDashboard />
  </Layout>
);

export const Route = createFileRoute('/dashboard')({
  component: DashboardPage,
  beforeLoad: ({ context }: any) => {
    // Redirect to login if not authenticated
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: '/' });
    }
  },
});
